import React from 'react'
import { Menu as UikitMenu } from '@thenexlabs/uikit'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import PhishingWarningBanner from 'components/PhishingWarningBanner'
import useTheme from 'hooks/useTheme'
import { usePriceXpBusd } from 'state/farms/hooks'
import { usePhishingBannerManager } from 'state/user/hooks'
import config from './config/config'
import UserMenu from './UserMenu'
import GlobalSettings from './GlobalSettings'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'
import { footerLinks } from './config/footerConfig'
import { Link } from "react-router-dom";

const Menu = (props) => {
  const { isDark, toggleTheme } = useTheme()
  const xpPriceUsd = usePriceXpBusd()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const pathname = window.location.pathname;
  const [showPhishingWarningBanner] = usePhishingBannerManager()

  const activeMenuItem = getActiveMenuItem({ menuConfig: config(t), pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  return (
    <UikitMenu
      /*linkComponent={(linkProps) => {
        return <Link to={linkProps.href} {...linkProps} prefetch={false} />
      }}*/
      userMenu={<UserMenu />}
      globalMenu={<GlobalSettings />}
      /*banner={showPhishingWarningBanner && typeof window !== 'undefined' && <PhishingWarningBanner />}*/
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      xpPriceUsd={xpPriceUsd.toNumber()}
      links={config(t)}
      subLinks={activeMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
      footerLinks={footerLinks(t)}
      activeItem={activeMenuItem?.href}
      activeSubItem={activeSubMenuItem?.href}
      buyXpLabel={t('Buy XP')}
      {...props}
    />
  )
}

export default Menu
